import { useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import { Button } from '../../components/common';
import SimulationMultipleClients from './Steps/SimulationMultipleClients';

export default function SimulationView() {
  const id = window.location.pathname.split('/').pop();
  const history = useHistory();
  return (
    <Box sx={{ mt: 10 }}>
      <Button variant="contained" onClick={history.goBack} sx={{ mb: 3 }}>
        WRÓĆ
      </Button>
      <SimulationMultipleClients resultID={id} noMargin />
    </Box>
  );
}
